<template>
    <Head>
        <title>Organization: Users</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <v-navigation v-if="organizationId" :organization-id="organizationId"/>
        </template>

        <div class="bg-white">

            <div class="grid grid-cols-4 p-2 gap-2 text-sm font-bold items-end">
                <span>Email</span>
                <span>Имя в организации</span>
                <span>Роль в организации</span>
                <v-button v-if="access('organizations', 'editable')" v-show="!showAdd" @click="show" color="blue">Добавить</v-button>
            </div>

            <form v-if="access('organizations', 'editable')" v-show="showAdd" class="grid grid-cols-4 p-2 gap-2 items-center" @submit.prevent="form.post(route('organization.user.add', organizationId))">
                <div class="flex flex-row">
                    <v-input placeholder="find" @input="search"/>
                    <v-select v-model="form.userId">
                        <option v-for="user in userFind" :value="user.id">{{ user.email }}</option>
                    </v-select>
                </div>
                <v-input v-model="form.name"/>
                <span>read-only</span>
                <v-button color="blue">Добавить</v-button>
            </form>

            <div class="grid grid-cols-4 p-2 gap-2 items-center border-t" v-for="user in users">
                <span>{{ user.email }}</span>
                <div class="col-span-2 flex flex-col gap-1">
                    <div class="grid grid-cols-2 gap-2 items-center" v-for="role in user.organizationRoles">
                        <span>{{ role.userRole.name }}</span>
                        <div class="flex flex-row gap-2 items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-current h-6 w-6" :class="role.isOwner ? 'text-blue-600' : 'text-gray-200'" viewBox="0 0 16 16">
                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                            </svg>
                            <div class="flex flex-col">
                                <span>{{ role.name }}</span>
                                <span class="text-xs text-gray-700">{{ role.comment }}</span>
                            </div>
                            <div class="flex-grow text-right" v-if="access('organizations', 'editable')">
                                <v-button @click="useForm({userId: user.id, organizationRoleId: role.id}).delete(route('organization.user.remove', organizationId))" color="red">X</v-button>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="text-right">
                    <Link :href="route('ocp.user', user.id)" class="p-2"> > </Link>
                </span>
            </div>

        </div>


    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/Organization';
import VButton from '@/Components/Button';
import VInput from '@/Components/Input';
import VSelect from '@/Components/Select';
import moment from 'moment';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
        VButton,
        VInput,
        VSelect,
    },
    props: {
        organizationId: String,
        users: Object,
        notifications: Array,
    },
    data() {
        return {
            showAdd: false,
            roles: [],
            userFind: [],
            form: useForm({
                    userId: null,
                    name: '',
                })
        }
    },
    methods: {
        moment,
        useForm,
        show() {
            this.showAdd = true;
        },
        search(e) {
            const {value} = e.target;
            if(value.length > 2)
                axios.post(this.route('users.find'), {search: value})
                    .then(res => {
                        this.userFind = res.data.rows;
                        this.form.userId = this.userFind[0].id;
                    });
        }
    },
}
</script>
